export const DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID =
  'DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID'

type NameSpace = {
  DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID?: undefined | string
} & ((Window & typeof globalThis) | typeof globalThis)

export const globalNamespace: NameSpace =
  // eslint-disable-next-line no-restricted-globals
  typeof self === 'undefined' ? global : self

globalNamespace[DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID] = undefined

/**
 * Sets a string on the Window or Global object that all ModalPortals will use as the targetId of the div they create/render in. If this is set it will override any targetId passed as a prop to ModalPortal.
 * @param id - The string the id will be set to
 */
export function setDsUiModalPortalId(
  id = DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID,
): void {
  globalNamespace[DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID] = id
}

/**
 * @returns The value that the global id is currently set to or undefined if it has not been set
 */
export function getDsUiModalPortalId(): undefined | string {
  return globalNamespace[DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID]
}

/**
 * Unsets the id and returns it to undefined
 */
export function unsetDsUiModalPortalId(): void {
  globalNamespace[DOCUSIGN_DS_UI_MODAL_GLOBAL_PORTAL_ID] = undefined
}
